import { PatientSearchPicker } from "@/components/PatientSearchPicker";
import { useTranslation } from "react-i18next";

import {
  compactOutlinedButtonSx,
} from "./externalRegisterAdminUi";

export const RelinkPatientSearch = ({
  selectedPatientId,
  onSelectPatient,
  disabled = false,
}: {
  selectedPatientId: string;
  onSelectPatient: (patientId: string) => void;
  disabled?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <PatientSearchPicker
      selectedPatientId={selectedPatientId}
      onSelectPatient={(patientId) => onSelectPatient(patientId)}
      label={t("externalRegister.admin.relinkSearch.label")}
      ariaLabel={t("externalRegister.admin.relinkSearch.ariaLabel")}
      selectedLabel={t("externalRegister.admin.relinkSearch.selectedLabel")}
      required
      disabled={disabled}
      selectButtonSx={compactOutlinedButtonSx}
    />
  );
};
